import { useMutation, useQueryClient } from '@tanstack/react-query';

type Params = { id: number; memo: string };

/**
 * 一覧のメモだけを PATCH する（フォーム全体の ProfitUpdateInput は不要）
 */
export default function usePatchProfitMemo() {
  const queryClient = useQueryClient();
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;

  return useMutation({
    mutationFn: async ({ id, memo }: Params) => {
      const res = await fetch(`/agent/api/profits/${id}`, {
        method: 'PATCH',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({ profit: { memo } }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.errors?.join(', ') || 'メモの更新に失敗しました');
      }
      return res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['/agent/api/profits'] });
    },
  });
}
